import './workstationError.scss'
import templateUrl from './workstationError.html'

/**
 * Route workstation error page.
 *
 * @namespace routes.WorkstationError
 * @type {TmrRoute}
 */
export const route = {
  name: 'workstationError',
  label: 'WORKSTATIONERROR.TITLE',
  component: 'tmrWorkstationError',
  params: {
    transitionState: null,
  },
}

/**
 * Component for the route workstation error.
 *
 * @type {ngComponent}
 */
export const tmrWorkstationError = {
  ngType: 'component',
  templateUrl,
}
